import React, { Component } from 'react'
import Select from 'react-select'

class AgentSearch extends Component {

  state = {
    location: null,
    role: null,
    searchPlaceholder: `Search by name or role`,
    search: '',
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        break
      case 'mount':
        let { name, value } = option.currentTarget
        let item = this[name]?.props?.options?.find(el => el.value === value)
        if (item) {
          state[name] = item
        }
        break
      case 'clear':
        state[field.name] = null
        break
      default:
        state[option.currentTarget.name] = option.currentTarget.value
        break
    }
    this.setState(state, this.updateList)
  }

  updateList = () => {
    const { list, set } = this.props
    const { location, role, search } = this.state

    let results = {}

    if (list) {
      results = list.filter((el, i) => {
        const { acf, teamDetails, title } = el
        let searchObject = {
          'title': title,
          'role': acf?.role,
        }
        const office = (acf.office?.length > 0 && acf.office[0]?.title) ? acf.office[0].title : teamDetails?.officeName?.replace('CobdenHayson ', '')
        const skills = acf.skills ? acf.skills : []
        if (role && !skills.includes(role.value)) return false
        if (location && office !== location.value) return false
        if (search && Object.keys(searchObject).map(key => searchObject[key]).join(' ').toLowerCase().indexOf(search.toLowerCase()) === -1) return false
        return true
      })
    }
    set(results)
  }

  render() {
    let { location, role, search, searchPlaceholder } = this.state
    let { locations } = this.props

    let locationOptions = []
    // loop over tags and categories and create options
    locations && locations.forEach(l => {
      locationOptions.push({ label: l, value: l })
    })
    const roleOptions = [
      { label: 'Sales', value: 'Sales' },
      { label: 'Property Management', value: 'Property Management' },
      { label: 'Administration', value: 'Admin' },
      { label: 'Directors', value: 'Director' }
    ]
    // return the label inside categories array where the value matches type
    return (
      <div className='search'>
        <div className="search__inner">
          <form className='search__form form'>
            <div className="form__row">
              <input className={`form__input`} type="text" name="search" value={this.state.search} placeholder={searchPlaceholder} onChange={this.handleSelectChange} />
              <div className='form__select form__select--category'>
                <Select
                  options={roleOptions}
                  onChange={this.handleSelectChange}
                  isSearchable={false}
                  openMenuOnFocus={true}
                  id="role"
                  name="role"
                  value={role}
                  placeholder="All Skills"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  isClearable={true}
                  ref={node => this.role = node}
                />
              </div>
              <div className='form__select form__select--location'>
                <Select
                  options={locationOptions}
                  onChange={this.handleSelectChange}
                  isSearchable={false}
                  openMenuOnFocus={true}
                  id="location"
                  name="location"
                  value={location}
                  placeholder="All Locations"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  isClearable={true}
                  ref={node => this.location = node}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AgentSearch